import {Injectable} from '@angular/core';
import {FormbirdInjectorService} from '../injector/formbird-injector.service';

@Injectable({
  providedIn: 'root'
})
export class FinaliseValueFieldService {
  ajsService: any;

  constructor(private injector: FormbirdInjectorService) {
    this.ajsService = injector.get('FinaliseValueFieldService');
  }

  addFinaliseValueFunction(templateId, fieldName, func) {
    this.ajsService.addFinaliseValueFunction(templateId, fieldName, func);
  }

  getFinaliseValueFunction(templateId, fieldName) {
    return this.ajsService.getFinaliseValueFunction(templateId, fieldName);
  }

  finaliseFieldValues(document, template) {
    this.ajsService.finaliseFieldValues(document, template);
  }
}
